
<div class="menu-container">
	<button ngbDropdownItem class="user__option--menu-item" gtagEvent="información-personal" gtagCategory="header" (click)="onMenuUsuarioClicked( '/perfil/informacion-personal' )">
		<div class="user__option--menu-icon user__option--informacion-personal-icon"></div>
		<div>Información personal</div>
	</button>
	<button *ngIf="aportePlanSaludEnabled$ | async" ngbDropdownItem class="user__option--menu-item" gtagEvent="aportes-plansalud" gtagCategory="header" (click)="onMenuUsuarioClicked( '/perfil/aportes-plansalud' )">
		<div class="user__option--menu-icon user__option--aportes-icon"></div>
		<div>Aportes al Plan de Salud</div>
	</button>
	<button *ngIf="comprobanteTesoreriaEnabled$ | async" ngbDropdownItem class="user__option--menu-item" gtagEvent="comprobantes-tesorería" gtagCategory="header" (click)="onMenuUsuarioClicked( '/perfil/comprobantes-tesoreria' )">
		<div class="user__option--menu-icon user__option--comprobantes-icon"></div>
		<div>Comprobantes</div>
	</button>
	<button *ngIf="capitaPacienteEnabled$ | async" ngbDropdownItem class="user__option--menu-item" gtagEvent="capita-pacientes" gtagCategory="header" (click)="onMenuUsuarioClicked( '/perfil/capita-pacientes' )">
		<div class="user__option--menu-icon user__option--capita-icon"></div>
		<div>Cápita de pacientes</div>
	</button>
	<button ngbDropdownItem class="user__option--menu-item" (click)="onOpenSugerencias.emit()" gtagEvent="sugerencias" gtagCategory="header">
		<div class="user__option--menu-icon user__option--sugerencias-icon"></div>
		<div>Sugerencias</div>
	</button>
	<button ngbDropdownItem class="user__option--menu-item" gtagEvent="seguridad" gtagCategory="header" (click)="onMenuUsuarioClicked( '/perfil/seguridad' )">
		<div class="user__option--menu-icon user__option--seguridad-icon"></div>
		<div>Seguridad</div>
	</button>
	<button ngbDropdownItem class="user__option--menu-item" gtagEvent="acerca-de-comunità" gtagCategory="header" routerLink="/principal/acerca-de-comunita">
		<div class="user__option--menu-icon user__option--acerca-de-icon"></div>
		<div>Acerca de Comunità</div>
	</button>
	<hr>
	<button ngbDropdownItem class="user__option--menu-item" (click)="onCloseSession()" gtagEvent="cerrar-sesión" gtagCategory="header">
		<div class="user__option--sesion-menu-icon user__option--menu-icon"></div>
		<div>Cerrar sesión</div>
	</button>
</div>
